import React from 'react';
import StaticText from 'components/form/field/static-text';
import { getFormLabel } from '../helpers';

export default ({ providers, field, input }) => (
  <StaticText fieldName={getFormLabel(providers, field)} field={input.value} />
);
